import React, {Component} from 'react'
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"

import Section from "../common/Section";

import AwardRow from './AwardRow'
import {Hr, View} from '@amzn/stencil-react-components/layout'
import AcceptAwardWizard from '../AcceptAwardWizard';

class AwardSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      award: null,
      isAcceptAwardWizardVisible: false,
      prevId: null
    };
  }

  getSectionTitle(awards, sectionTitle, t) {
    if (awards && awards.length > 0) {
      return sectionTitle;
    }

    return t("StockAwards.NoAwardsMessage");
  }

  onAwardNotAcceptedLabelClick = (award, id) => {
    this.setState({
      award: award,
      isAcceptAwardWizardVisible: true,
      prevId: id
    });

  };

  onAcceptAwardWizardClose = () => {
    this.setState({
        isAcceptAwardWizardVisible: false
    });
  };

  render() {
    const {awards, t} = this.props;

    const sectionTitle = this.getSectionTitle(awards, this.props.sectionTitle, t);
    const hasAwards = awards && awards.length > 0;

    return (
      <Section title={sectionTitle} shouldExpandOnMount={hasAwards}>
            {hasAwards && (
              <>
                {awards.map((award) => {
                  return (
                    <>
                      <AwardRow
                        award={award}
                        isTaxHidden={this.props.isTaxHidden}
                        onAwardNotAcceptedLabelClick={(id) => this.onAwardNotAcceptedLabelClick(award, id)}
                        onChangePaymentMethodClick={this.props.onChangePaymentMethodClick}
                        onRowMenuItemClick={this.props.onAwardMenuItemClick}
                      />
                      <View margin={15}>
                        <Hr/>
                      </View>
                    </>
                  );
                })}
              </>
            )}

            {this.state.isAcceptAwardWizardVisible &&
              <AcceptAwardWizard
                award={this.state.award}
                prevFocusItem={this.state.prevId}
                onWizardClose={this.onAcceptAwardWizardClose}
              />
            }

      </Section>
    )
  }
}

const mapState = state => ({
  brokerName: state.employee.broker ? state.employee.broker.name : ''
})

export default connect(mapState)(withTranslation('translationsV2')(AwardSection))
